import { Tables } from '@/types/database.types';
import { CustomQueryOptions } from '@/types/query';
import { useQuery } from '@tanstack/react-query';
import { getStorageLogsByProjectId, getStorageLogsByUserId } from '.';
import { GetStorageLogsByProjectIdParams, GetStorageLogsByUserIdParams } from './type';

const keyname = 'storage-log';

export const useGetStorageLogsByProjectId = (
  params: GetStorageLogsByProjectIdParams,
  option?: CustomQueryOptions<Tables<'storage_log'>[]>
) => {
  return useQuery({
    queryKey: [keyname, params.project_id],
    queryFn: () => getStorageLogsByProjectId(params),
    enabled: !!params.project_id,
    ...option,
  });
};

export const useGetStorageLogsByUserId = (
  params: GetStorageLogsByUserIdParams,
  option?: CustomQueryOptions<Tables<'storage_log'>[]>
) => {
  return useQuery({
    queryKey: [keyname, 'user', params.user_id],
    queryFn: () => getStorageLogsByUserId(params),
    enabled: !!params.user_id,
    ...option,
  });
};
